import * as React from 'react';

import Microphone140 from './Microphone140';

export const microphone140 = () => <Microphone140 />;

export default {
    title: 'Illustration/Microphone140',
    component: Microphone140,
    parameters: {
        notes: "`import Microphone140 from 'box-ui-elements/es/illustration/Microphone140';`",
    },
};
